import { DataTableRow } from 'cpool-components/general/DataTable';

import { AttributionCell } from './cells/AttributionCell';
import { ConfirmationCell } from './cells/ConfirmationCell';
import { FileNameCell } from './cells/FileNameCell';
import { RowActions } from './cells/RowActions';
import { UploadStatusCell } from './cells/UploadStatusCell';
import type { SchemaRecordedDocumentListEntry } from '~/features/leadDetails/schemas/recordedDocuments.schema';
import { dateFormat } from '~/lib/i18n';
import { cn } from '~/utils/cnTailwind';

type Props = {
    document: SchemaRecordedDocumentListEntry;
    hasSecondApplicant: boolean;
    leadId: string;
    /** Sorting keys read by the DataTable — supplied by the table so it can partition its children. */
    payload: Record<string, unknown>;
};

const cellClass = 'px-4 py-2 text-sm text-midnight';

export const DocumentRow: React.FC<Props> = ({ document, hasSecondApplicant, leadId, payload }) => {
    const { confirmedDate, fileFormat, fileName } = document;
    const isConfirmed = confirmedDate !== null;
    // fileFormat is optional; avoid "<name>.undefined"
    const downloadName = fileFormat ? `${fileName}.${fileFormat}` : fileName;

    return (
        <DataTableRow
            payload={payload}
            data-testid={`document-center-row-${document.key}`}
            className="odd:bg-white even:bg-surface-light hover:bg-grey-table-hover"
        >
            <td className={cellClass}>
                <ConfirmationCell confirmed={isConfirmed} documentKey={document.key} leadId={leadId} />
            </td>
            <td className={cn(cellClass, 'whitespace-nowrap')}>
                <FileNameCell documentKey={document.key} fileName={fileName} leadId={leadId} />
            </td>
            <td className={cellClass}>{fileFormat ?? ''}</td>
            <td className={cn(cellClass, 'whitespace-nowrap')}>{dateFormat(document.uploadDate)}</td>
            <td className={cn(cellClass, 'whitespace-nowrap')}>{confirmedDate ? dateFormat(confirmedDate) : '–'}</td>
            {hasSecondApplicant && (
                <td className={cn(cellClass, 'whitespace-nowrap')}>
                    <AttributionCell attribution={document.attribution} documentKey={document.key} leadId={leadId} />
                </td>
            )}
            <td className={cn(cellClass, 'text-center')}>
                <UploadStatusCell documentKey={document.key} leadId={leadId} uploadedTo={document.uploadedTo} />
            </td>
            <td className={cellClass}>
                <RowActions
                    documentKey={document.key}
                    documentName={downloadName}
                    leadId={leadId}
                    mimeType={document.mimeType}
                />
            </td>
        </DataTableRow>
    );
};
